"use client";
import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";

export type WcTextFieldProps = TextFieldProps & {
  controlDisabled?: boolean;
  useFullWidth?: boolean;
};

export const WcTextField = ({ useFullWidth = true, controlDisabled, value, sx, ...props }: WcTextFieldProps) => (
  <TextField
    id="TextField"
    disabled={controlDisabled}
    fullWidth={useFullWidth}
    value={value || ""}
    sx={[...(Array.isArray(sx) ? sx : [sx])]}
    {...props}
  />
);

export default WcTextField;
